<template>
  <div class="d-flex flex-column"
    v-touch:swipe.left.prevent.stop="increaseIndex"
    v-touch:swipe.right.prevent.stop="decreaseIndex">
    <div class="w-100 mb-3 mb-md-0">
      <label class="text-secondary mb-0" :class="{ 'text-danger font-weight-bold': localShowUnselected && value === null || showUnselected && value === null }">{{label}}</label>
    </div>
    <div role="list" 
      class="d-flex justify-content-between align-items-center w-100 scroll-items-container px-md-2" 
      style="max-height: 106px;" 
      :class="{
        'border-bottom border-danger': localShowUnselected && value === null || showUnselected && value === null,
      }">
      <button 
        :class="{
          'disabled text-light': items.length <= visibleItemsCount || value
        }"
        :disabled="items.length <= visibleItemsCount || value"
        class="bg-transparent border-0 font-weight-bold px-md-3 py-md-2 clickable text-saka-green"
        @click.prevent="decreaseIndex()">
        <h4><i class="fas fa-chevron-left"></i></h4>
      </button>
      <component
        v-for="item in pages[page]"
        :is="type"
        :key="item.replace(/ /g, '-')"
        :title="item"
        :color="color"
        :plex="plex"
        :mode="mode"
        :fiber-count="fiberCount"
        :plug-id="plugId"
        @click.native="(!itemIsDisabled(item) ? setvalue(item): '')"
        :isActive="item === localValue"
        :disabled="itemIsDisabled(item)"
        :class="{ 
          'disabled' : itemIsDisabled(item),
          'flex-grow-1': true
        }"
        role="button"
      />
      <button 
        @click="increaseIndex()"
        :disabled="items.length <= visibleItemsCount  || value"
        class="bg-transparent text-saka-green border-0 font-weight-bold px-md-3 py-md-2 clickable"
        :class="{
          'disabled text-light': items.length <= visibleItemsCount  || value
        }">
        <h4><i class="fas fa-chevron-right"></i></h4>
      </button>
    </div>
    <div 
      class="w-100 d-flex justify-content-center mt-2 text-light-grey"
      v-if="items.length > visibleItemsCount">
      <span
        v-for="n in pages.length"
        :key="`${n}-indicator`"
        :class="{
          'text-saka-orange' : n === (page + 1)
        }"
        class="mx-1"
      >&bull;</span>
    </div>

  </div>
</template>

<script>
// these components get used in the <component> tag
// via the :is prop
import CarouselScrollSelectPlugType from '@/components/CarouselScrollSelectPlugType'
import CarouselScrollSelectCableType from '@/components/CarouselScrollSelectCableType'

import { mapGetters } from 'vuex'
import Bowser from 'bowser'

export default {
  model: {
    prop: "value",
    event: "update"
  },
  name: 'CarouselScrollSelect',
  props: {
    type: String, 
    visibleItemsCount: {
      type: Number,
      default: 3
    }, 
    items: {
      type: Array,
      default: () => []
    },
    // disabled displayItems since sorting to available comes into the mix :(((((((
    // displayItems: {
    //   type: Array,
    //   default: () => []
    // },
    filterKey: {
      type: String,
      required: true
    },
    filterPropertyName: {
      type: String,
      required: true
    },
    label: String,
    value: String,
    // selectedColor: String,
    disabledItems: {
      type: Array,
      default: () => []
    },
    plex: String,
    color: String,
    fiberCount: String,
    mode: String,
    plugId: String,
    showUnselected: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CarouselScrollSelectPlugType, 
    CarouselScrollSelectCableType
  },
  data () {
    return {
      currentIndex: 0,
      localValue: this.value,
      browser: Bowser.getParser(window.navigator.userAgent),
      localShowUnselected: this.showUnselected,
      page: 0,
      blockAutoFillAfterUnselect: false
    }
  },
  methods: {
    // pagination via the currentIndex
    decreaseIndex () {
      this.currentIndex = ((this.currentIndex - this.visibleItemsCount) + this.items.length) % this.items.length
      if (this.page > 0)
        return this.page -= 1
      this.page = this.pages.length - 1
    },
    increaseIndex () {
      this.currentIndex = (this.currentIndex + this.visibleItemsCount) % this.items.length
      if (this.page < (this.pages.length - 1))
        return this.page += 1
      this.page = 0
    },

    itemIsDisabled (item) {
      return this.disabledItems.indexOf(item)>= 0
    },
    // set local state and inform parent 
    // about the value change
    setvalue (value) {
      if (this.localValue === value) {
        this.localValue = null
        
        this.$emit('update', null)
        try {
          // if (this.lastFilter(this.filterKey) === this.filterPropertyName) {
          //   this.$store.dispatch('tryRemoveAutoAppliedFilters', { filterKey: this.filterKey })
          // }
          this.blockAutoFillAfterUnselect = true
          this.$store.dispatch('removeAutoAppliedFiltersAndLastFilterAndFilter', { filterKey: this.filterKey, propertyName: this.filterPropertyName })
        } catch (err) {
          this.$rollbar.error('Can not set filter to store', err)
        }
        return
      }
      this.localValue = value
      
      this.$emit('update', value)
      try {
        this.blockAutoFillAfterUnselect = false
        this.$store.dispatch('setLastFilterAndFilter', { filterKey: this.filterKey, propertyName: this.filterPropertyName, propertyValue: value })
      } catch (err) {
        this.$rollbar.error('Can not set filter to store', err)
      }

      if (this.value) this.localShowUnselected = false
    },
    displayItem (index) {
      if (this.items.length === this.displayItems)
        return this.displayItems[index]
      return this.items[index]
    },
    // scroll to selected node after page switch
    scrollToSelectedItem () {
      if (this.value && this.pages[this.page] && !this.pages[this.page].includes(this.value))
        this.page =  this.pages.findIndex(page => page.includes(this.value))
    }
  },
  computed: {
    // circular array that is cycled with
    // modulo index 
    circularItems () {
      if(this.items.length >= this.visibleItemsCount) {
        return this.items.concat(this.items).slice(this.currentIndex, (this.currentIndex + this.visibleItemsCount))
      }
      else
        return this.items.concat(this.items).slice(this.currentIndex, (this.currentIndex + this.items.length))
    },
    pages () {
      const chunk = (arr, size) => (
        arr.reduce((acc, _, i) => {
          if (i % size === 0) acc.push(arr.slice(i, i + size))
          return acc
        }, [])
      )

      const pages = chunk(this.items, this.visibleItemsCount)

      return pages
    },
    ...mapGetters([
      'lastFilter'
    ])
  },
  watch: {
    value (newValue) {
      this.scrollToSelectedItem()
      this.localValue = newValue
      if (newValue) this.localShowUnselected = false
    },
    disabledItems (newValue) {
      if (newValue.length + 1 === this.items.length) {
        if (!this.blockAutoFillAfterUnselect)
          this.$store.dispatch('trySetAutoFillValues', { scope: 'getters', filterKey: this.filterKey, propertyName: this.filterPropertyName })
      }

      // scroll to the first selectable value
      if (this.localValue === null // if nothing is allready selected
        && this.disabledItems.length > 0  // items are disabled
        && this.circularItems.filter(item => this.disabledItems.includes(item)).length >= 2) { // and the displayed items do not contain something selectable
        // console.log('autoscroll')
        this.currentIndex = this.items.findIndex(item => !this.disabledItems.includes(item)) + 1
      }
    },
    showUnselected (newValue) {
      this.localShowUnselected = newValue
    }
  },
  mounted () {
    this.scrollToSelectedItem()
  }
}
</script>